import { forwardRef } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import TrackerMonthlyCalendar from './TrackerMonthlyCalendar'
import { useTheme } from '@emotion/react'

export default forwardRef(function TrackerCalendarContent(
    { calendarValue, filters, apiFilter, selectedProjectIds = [], onDayClick, onEventClick, selectedEmployees = [] },
    ref
) {
    const theme = useTheme()
    useMediaQuery(theme.breakpoints.up('tablet')) // harmless even if unused

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid #E5E5E5',
                borderRadius: '16px',
                overflow: 'auto',
                maxHeight: { xs: 'calc(100vh - 200px)', md: 'calc(100vh - 197px)' },
                bgcolor: '#FFFDF8',
                boxShadow: '0 18px 40px rgba(15, 23, 42, 0.06)',
                width: 1,
            }}
            className="scrollbar"
        >
            <TrackerMonthlyCalendar
                ref={ref}
                calendarValue={calendarValue}
                filters={filters}
                apiFilter={apiFilter}
                selectedProjectIds={selectedProjectIds}
                onDayClick={onDayClick}
                onEventClick={onEventClick}
                selectedEmployees={selectedEmployees}
            />
        </Box>
    )
})
